import { getCanonicalPostUrl } from '@wix/communities-blog-client-common';

export const getTagListItems = (posts, postPageSectionUrl) =>
  posts.map((post) => `${getCanonicalPostUrl({ post, postPageSectionUrl })}/`);
